import {
  instance as adminInstance,
  multipartInstance,
} from "../BaseUrl/BaseUrl";
import { handleErrors, showErrorToast, showSuccessToast } from "../Utils/util";

const buildUrl = (endpoint, id, queryParams) => {
  let url = `/${endpoint}${id ? `/${id}` : ""}`;
  if (queryParams && queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }
  return url;
};

const handleResponse = (result) => {
  if (result.status === 200 || result.status === 201) {
    const { data, message, status } = result.data;

    if (status) {
      message && showSuccessToast(message);
      return data || {};
    } else {
      throw new Error("Failed to process data");
    }
  } else {
    showErrorToast("Request failed");
  }
};

const sendData = async ({
  method,
  endpoint,
  formData,
  id,
  useFile = false,
}) => {
  try {
    const url = buildUrl(endpoint, id);
    const instance = useFile ? multipartInstance : adminInstance;
    const result = await instance[method](url, formData);
    return handleResponse(result);
  } catch (err) {
    handleErrors(err);
  }
};

const fetchData = async ({
  endpoint,
  currentPage,
  itemsPerPage,
  filters,
  paginate = true,
  id,
  selectedTab,
  hotelAdmin = false,
  ...additionalParams
}) => {
  try {
    const queryParams = new URLSearchParams();
    if (currentPage) queryParams.append("page", currentPage);
    if (itemsPerPage) queryParams.append("limit", itemsPerPage);
    if (filters && filters.trim()) queryParams.append("search", filters.trim());
    if (selectedTab) queryParams.append("action", selectedTab);
    queryParams.append("paginate", paginate);

    // Append additional parameters
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });
    const url = buildUrl(endpoint, id, queryParams);
    const result = await adminInstance.get(url);
    if (result.status === 200) {
      const { meta, data, status } = result.data;
      if (status) {
        let totalPages = 0;
        let totalItems = 0;
        if (paginate) {
          totalPages = Math.ceil(meta.total / itemsPerPage);
        }
        totalItems = (meta && meta.total) || data.length;
        return { data, totalPages, totalItems };
      } else {
        throw new Error("Failed to fetch data");
      }
    }
  } catch (err) {
    handleErrors(err);
  }
};

// Reusable function to fetch data for an endpoint Get Single Data
const getOneItem = async (endpoint, id) => {
  try {
    const url = buildUrl(endpoint, id);
    const result = await adminInstance.get(url);
    return handleResponse(result);
  } catch (err) {
    handleErrors(err);
    throw err;
  }
};

const createItemJson = (params) => sendData({ ...params, method: "post" });
const updateItemJson = (params) => sendData({ ...params, method: "patch" });
const createItemFile = (params) =>
  sendData({ ...params, method: "post", useFile: true });
const updateItemFile = (params) =>
  sendData({ ...params, method: "patch", useFile: true });

const deleteItem = async ({
  endpoint,
  id,
  setDeleteOpen,
  deleteOpen,
  undo = false,
}) => {
  try {
    const method = undo ? "put" : "delete";
    const url = buildUrl(endpoint, undo ? `undo-delete/${id}` : `delete/${id}`);
    const result = await adminInstance[method](url);
    if (handleResponse(result)) {
      if (!undo) setDeleteOpen(!deleteOpen);
      return { id };
    }
  } catch (err) {
    handleErrors(err);
  }
};

const fetchDataNoPag = async ({ endpoint, idOrSlug, ...additionalParams }) => {
  try {
    const queryParams = new URLSearchParams();
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });
    const url = buildUrl(endpoint, idOrSlug, queryParams);
    const result = await adminInstance.get(url);
    if (result.status === 200) {
      const { data, status } = result.data;
      if (status) {
        return data;
      }
    }
  } catch (err) {
    handleErrors(err);
  }
};
export {
  fetchData,
  getOneItem,
  deleteItem,
  createItemJson,
  updateItemJson,
  createItemFile,
  updateItemFile,
  fetchDataNoPag,
};
